import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import GroupsDetailsSectionInfo from '../sections/GroupsDetailsSectionInfo';

export default function GroupsDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={12}>
				<DetailsSectionInfoWrapper
					avatar={<Icon icon="text-subject" />}
					title={t('DETAILS_INFO_SECTION')}
					subheader={t('DETAILS_INFO_SUBHEADER')}
				>
					<GroupsDetailsSectionInfo
						model={props.model}
						sendChange={props.sendChange}
						isEdit={props.isEdit}
						logProps={props.logProps}
					/>
				</DetailsSectionInfoWrapper>
			</Grid>
			<Grid size={12}>
				<DetailsSectionDescription
					name="grps_descriptionhtml"
					value={props.model.grps_descriptionhtml}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				<DetailsSectionNotes module="groups" uid={props.model.grps_uid} />
			</Grid>
		</Grid>
	);
}
